<template>
    <div>
        <Head :title="building.name" />

        <!-- Header bâtiment -->
        <div class="bg-white rounded-md shadow p-6 mb-6">
            <div class="flex justify-between items-start">
                <div>
                    <h1 class="text-2xl font-bold">{{ building.name }}</h1>
                    <div class="text-gray-500 text-sm mt-1">
                        <span v-if="building.code">Code : {{ building.code }} · </span>
                        <span v-if="building.type">Type : {{ building.type }} · </span>
                        <span v-if="building.organization">{{ building.organization }}</span>
                    </div>
                    <p v-if="building.description" class="mt-2 text-gray-600">{{ building.description }}</p>
                </div>
                <span :class="statusClass(building.status)" class="px-3 py-1 rounded-full text-sm font-semibold">{{ building.status || '—' }}</span>
            </div>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4 text-sm">
                <div><span class="text-gray-500">Surface</span><br /><strong>{{ building.surface_m2 ? building.surface_m2 + ' m²' : '—' }}</strong></div>
                <div><span class="text-gray-500">Étages</span><br /><strong>{{ building.floors ?? '—' }}</strong></div>
                <div><span class="text-gray-500">Année</span><br /><strong>{{ building.year_built ?? '—' }}</strong></div>
            </div>
        </div>

        <!-- KPIs -->
        <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            <div class="bg-white rounded-md shadow p-4 text-center">
                <div class="text-3xl font-bold text-indigo-600">{{ stats.total_tickets }}</div>
                <div class="text-sm text-gray-500 mt-1">Tickets total</div>
            </div>
            <div class="bg-white rounded-md shadow p-4 text-center">
                <div class="text-3xl font-bold text-orange-500">{{ stats.open_tickets }}</div>
                <div class="text-sm text-gray-500 mt-1">Tickets ouverts</div>
            </div>
            <div class="bg-white rounded-md shadow p-4 text-center">
                <div class="text-3xl font-bold text-green-600">{{ stats.equipment_ok }}</div>
                <div class="text-sm text-gray-500 mt-1">Équipements OK</div>
            </div>
            <div class="bg-white rounded-md shadow p-4 text-center">
                <div class="text-3xl font-bold text-red-500">{{ stats.equipment_ko }}</div>
                <div class="text-sm text-gray-500 mt-1">Équipements KO</div>
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Équipements -->
            <div class="bg-white rounded-md shadow">
                <div class="px-6 py-4 border-b font-semibold flex justify-between items-center">
                    <span>Équipements ({{ equipment.length }})</span>
                    <Link :href="route('equipment.index') + '?building_id=' + building.id" class="text-indigo-600 text-sm hover:underline">Voir tout</Link>
                </div>
                <table class="min-w-full text-sm">
                    <tr v-for="e in equipment" :key="e.id" class="border-t hover:bg-gray-50">
                        <td class="px-6 py-2">{{ e.name }}</td>
                        <td class="px-6 py-2 text-gray-500">{{ e.type || '—' }}</td>
                        <td class="px-6 py-2">
                            <span :class="equipStatusClass(e.status)" class="px-2 py-0.5 rounded-full text-xs font-semibold">{{ e.status || '—' }}</span>
                        </td>
                        <td class="px-6 py-2 text-xs text-gray-500">{{ e.next_maintenance_date || '—' }}</td>
                    </tr>
                    <tr v-if="equipment.length === 0">
                        <td class="px-6 py-3 text-gray-400" colspan="4">Aucun équipement.</td>
                    </tr>
                </table>
            </div>

            <!-- Tickets récents -->
            <div class="bg-white rounded-md shadow">
                <div class="px-6 py-4 border-b font-semibold">Tickets récents</div>
                <table class="min-w-full text-sm">
                    <tr v-for="t in recent_tickets" :key="t.id" class="border-t hover:bg-gray-50">
                        <td class="px-6 py-2">
                            <Link :href="route('tickets.edit', t.uid || t.id)" class="text-indigo-600 hover:underline">#{{ t.uid || t.id }}</Link>
                        </td>
                        <td class="px-6 py-2">{{ t.subject }}</td>
                        <td class="px-6 py-2 text-gray-500">{{ t.status }}</td>
                    </tr>
                    <tr v-if="recent_tickets.length === 0">
                        <td class="px-6 py-3 text-gray-400" colspan="3">Aucun ticket.</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
    layout: Layout,
    components: { Link, Head },
    props: {
        building: Object,
        equipment: Array,
        recent_tickets: Array,
        stats: Object,
    },
    methods: {
        statusClass(s) {
            return {
                'bg-green-100 text-green-700': s === 'actif',
                'bg-red-100 text-red-700': s === 'inactif',
                'bg-yellow-100 text-yellow-700': s === 'en_travaux',
                'bg-gray-100 text-gray-600': !s,
            }
        },
        equipStatusClass(s) {
            return {
                'bg-green-100 text-green-700': s === 'operationnel',
                'bg-yellow-100 text-yellow-700': s === 'en_maintenance',
                'bg-red-100 text-red-700': s === 'en_panne' || s === 'hors_service',
                'bg-gray-100 text-gray-600': !s,
            }
        },
    },
}
</script>
